export const isRuntimeInsideNodeServer = () => typeof window === "undefined";

export const isTouchDevice = () => {
  if (!isRuntimeInsideNodeServer()) {
    return !!window?.ontouchstart || navigator?.maxTouchPoints > 0;
  }
  return false;
};
